import { render, staticRenderFns } from "./DialogStaffDelete.vue?vue&type=template&id=d5427b32&scoped=true"
import script from "./DialogStaffDelete.vue?vue&type=script&lang=js"
export * from "./DialogStaffDelete.vue?vue&type=script&lang=js"
import style0 from "./DialogStaffDelete.vue?vue&type=style&index=0&id=d5427b32&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d5427b32",
  null
  
)

export default component.exports